






















import { postBanner } from '@/api/banner';
import { ElForm } from 'element-ui/types/form';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BannerCreate extends Vue {
  private banner = {
    name: '',
    width: 1,
    height: 1,
  };

  private restricted = false;
  private submitting = false;

  get rules() {
    const rules: Record<string, Array<object>> = {
      name: [
        { required: true, message: '请输入名称', trigger: 'blur' },
        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
      ],
    };
    if (this.restricted) {
      rules.width = rules.height = [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { type: 'number', min: 1, message: '必须是正数', trigger: 'blur' },
      ];
    }
    return rules;
  }

  public async submit() {
    const form = this.$refs.form as ElForm;
    const valid = await form.validate().catch((v) => v);
    if (valid) {
      const data = this.restricted ? this.banner : { name: this.banner.name };
      const timeout = window.setTimeout(() => (this.submitting = true), 500);
      try {
        const { banner, restricted } = this;
        const data = {
          name: banner.name,
          restriction: restricted
            ? {
                width: banner.width,
                height: banner.height,
              }
            : undefined,
        };
        await postBanner(data);
        form.resetFields();
        this.$router.back();
      } catch (e) {
        throw e;
      } finally {
        window.clearTimeout(timeout);
        this.submitting = false;
      }
    }
  }
}
